import script from "./LaputaEditProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaEditProfile.vue?vue&type=script&setup=true&lang=js"

import "./LaputaEditProfile.vue?vue&type=style&index=0&id=22fb7dfb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22fb7dfb"]])

export default __exports__